import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyInfo } from '../models/currency-info';

@Pipe({ name: 'gcy', standalone: true })
export class GameCurrencyPipe implements PipeTransform {
    transform(
        value: number,
        currency: CurrencyInfo | undefined | null,
        getRawValue: boolean = false,
        autoFormatDecimals = false,
        asObject = false
    ): string {
        if (!currency) { return value.toString(); }
        if (getRawValue) { return (value / currency.multiplier).toString() }

        let withoutDecimal = currency.withoutDecimal
        if (autoFormatDecimals) {
            withoutDecimal = (value / currency.multiplier) % 1 === 0
        }
        let retVal = (value / currency.multiplier).toLocaleString('en-US', { minimumFractionDigits: (currency && !withoutDecimal) ? currency.nbDecimalVisible : 0, maximumFractionDigits: (currency && !withoutDecimal) ? currency.nbDecimalVisible : 0 });

        if (!currency.symbol) { return retVal; }

        retVal = currency.symbolAfter ? `${retVal}${currency.symbol}` : `${currency.symbol}${retVal}`;

        return retVal;
    }
}
